import numeral from 'numeral'

numeral.register('locale', 'de-ch', {
  delimiters: {
    thousands: "'",
    decimal: '.',
  },
  abbreviations: {
    thousand: 'k',
    million: 'm',
    billion: 'b',
    trillion: 't',
  },
  ordinal: function(number) {
    return number.toString()
  },
  currency: {
    symbol: 'CHF',
  },
})
